import styled from 'styled-components';

export const FieldErrorMessage = styled.p`
  color: #ff4d4f;
  background-color: transparent;
`;
